import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import ModalRemover from '../ModalRemover';
import { fetchApi } from '../../services/api';
import Loading from '../../components/Loading';
import Alert from '../Alert';
import Button from '../Button';
import { getStorage } from '../../utils/storage';
import { getLink } from '../../services/host';
import { FaEdit, FaTrash, FaUsers } from 'react-icons/fa';

import './style.css';

class ListPesquisadores extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pesquisadores: props.pesquisadores,
      remover: null,
      isLoading: false,
      list: [],
      successMessages: [],
      errorMessages: [],
    };

    this.removerPesquisador = this.removerPesquisador.bind(this);
    this.getListPesquisadores = this.getListPesquisadores.bind(this);
  }

  componentWillMount() {
    //recupera cadastro de aplicadores
    this.getListPesquisadores();
  }

  removerPesquisador(id) {
    this.setState({
      successMessages: [],
      errorMessages: [],
    });

    this.setState({
      remover: (
        <ModalRemover
          remover={() => {
            this.deletePesquisador(id);
          }}
          onClick={() => {
            this.setState({ remover: null });
          }}
        />
      ),
    });
  }

  getListPesquisadores() {
    //ativa loading
    this.setState({
      remover: null,
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .get(
        this.state.pesquisadores
          ? process.env.REACT_APP_PESQUISADOR_LIST
          : process.env.REACT_APP_ADMIN_LIST,
      )
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //lista dados
          this.setState({
            list: response.data.dados,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });
      });
  }

  deletePesquisador(id) {
    //ativa loading
    this.setState({
      remover: null,
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    console.log(id);

    fetchApi
      .delete(
        this.state.pesquisadores
          ? process.env.REACT_APP_PESQUISADOR_DELETE
          : process.env.REACT_APP_ADMIN_DELETE,
        id,
      )
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //recarrega aplicadores
          this.getListPesquisadores();

          //mostra mensagem
          this.setState({
            successMessages: response.data.messages,
          });
        } else {
          this.setState({
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  filterList() {
    const busca = this.props.busca?.toLowerCase() ?? '';
    return this.state.list.filter((value) => {
      return (
        value.nome.toLowerCase().includes(busca) ||
        value.email.toLowerCase().includes(busca)
      );
    });
  }

  render() {
    return (
      <div id="list-pesquisadores">
        <div className="container">
          {this.state.successMessages.length > 0 ? (
            <Alert tipo="success" messages={this.state.successMessages} />
          ) : null}
          {this.state.errorMessages.length > 0 ? (
            <Alert tipo="error" messages={this.state.errorMessages} />
          ) : null}

          <div className="list">
            {this.filterList().length > 0 ? (
              <Fragment>
                <div className="list-hrow">
                  <div className="list-item">
                    Nome do{' '}
                    {this.state.pesquisadores ? 'aplicador' : 'administrador'}
                  </div>
                  <div className="list-item">E-mail</div>
                  <div className="list-item">
                    {this.state.pesquisadores ? 'Telefone' : ''}
                  </div>
                  <div className="list-item">Ações</div>
                </div>

                {this.filterList().map((value, index) => {
                  return (
                    <div className="list-body" key={`item-` + index}>
                      <div className="list-item">{value.nome}</div>
                      <div className="list-item">{value.email}</div>
                      <div className="list-item">
                        {this.state.pesquisadores ? value.telefone : ''}
                      </div>

                      {this.state.pesquisadores ? (
                        <div className="list-item actions-container">
                          {getStorage('isMemnon') && (
                            <Button
                              link={getLink(
                                `/pesquisador/${value.id_pesquisador}/pacientes`,
                              )}
                              variant="primary"
                              size="small"
                              icon={<FaUsers />}
                              className="action-btn"
                            >
                              Pacientes
                            </Button>
                          )}
                          <Button
                            link={getLink(
                              `/editar-pesquisador/${value.id_pesquisador}`,
                            )}
                            variant="success"
                            size="small"
                            icon={<FaEdit />}
                            className="action-btn"
                          >
                            Editar
                          </Button>
                          <Button
                            variant="danger"
                            size="small"
                            icon={<FaTrash />}
                            onClick={() => {
                              this.removerPesquisador(value.id_pesquisador);
                            }}
                            className="action-btn"
                          >
                            Remover
                          </Button>
                        </div>
                      ) : (
                        <div className="list-item actions-container">
                          <Button
                            link={getLink(
                              `/editar-administrador/${value.id_administrador}`,
                            )}
                            variant="success"
                            size="small"
                            icon={<FaEdit />}
                            className="action-btn"
                          >
                            Editar
                          </Button>
                          <Button
                            variant="danger"
                            size="small"
                            icon={<FaTrash />}
                            onClick={() => {
                              this.removerPesquisador(value.id_administrador);
                            }}
                            className="action-btn"
                          >
                            Remover
                          </Button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </Fragment>
            ) : (
              <div className="nenhum-registro">
                Nenhum{' '}
                {this.state.pesquisadores ? 'aplicador' : 'administrador'}{' '}
                encontrado.
              </div>
            )}
          </div>
        </div>

        {this.state.remover}

        {this.state.isLoading ? <Loading /> : null}
      </div>
    );
  }
}

export default ListPesquisadores;
